import React, { useMemo } from 'react';
import { CenteredFlexBox } from '../../Components/FlexBox';
import Select from '../../Components/Inputs/Select';
import IconButton from '../../Components/Button/IconButton';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

const ConfigurationsOptions = function ConfigurationsOptions({
  pivotConfigurations,
  selectedConfiguration,
  handleChangeSelectedConfiguration,
  onClickEdit,
  onClickDelete,
  isSupervisor,
  disabled,
  onSave,
  currentDescription,
}) {
  const configurationOptions = useMemo(
    () =>
      isSupervisor
        ? [
            {
              value: 0,
              label:
                selectedConfiguration === 0
                  ? (currentDescription?.name ?? 'CREATE_NEW')
                  : 'CREATE_NEW',
            },
            ...pivotConfigurations.map(({ id, name }) => ({
              value: id,
              label: name,
            })),
          ]
        : [
            ...pivotConfigurations.map(({ id, name }) => ({
              value: id,
              label: name,
            })),
          ],
    [pivotConfigurations, isSupervisor, currentDescription]
  );

  return (
    <CenteredFlexBox gap="24px">
      <Select
        width="40%"
        name="pivotConfiguration"
        label="PIVOT_CONFIGURATION"
        options={configurationOptions}
        value={selectedConfiguration}
        onChange={handleChangeSelectedConfiguration}
      />
      <CenteredFlexBox
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: '50px',
        }}
      >
        {isSupervisor && (
          <IconButton
            id="edit-template-icnBtn"
            title="EDIT_DESCRIPTION"
            size="large"
            onClick={onClickEdit}
            disabled={disabled}
          >
            <EditIcon />
          </IconButton>
        )}
        {isSupervisor && (
          <IconButton
            id="delete-template-icnBtn"
            title="DELETE"
            size="large"
            onClick={onClickDelete}
            disabled={disabled || selectedConfiguration === 0}
          >
            <DeleteIcon />
          </IconButton>
        )}
        {isSupervisor && (
          <IconButton
            id="delete-template-icnBtn"
            title="SAVE_CONFIGURATION"
            size="large"
            onClick={onSave}
            disabled={disabled || currentDescription?.name === ''}
          >
            <SaveRoundedIcon />
          </IconButton>
        )}
      </CenteredFlexBox>
    </CenteredFlexBox>
  );
};

export default ConfigurationsOptions;
